/**
 * Models often emit Basecamp notes as HTML-entity-escaped tags
 * (`&lt;pre&gt;` instead of `<pre>`). Decode before preview or PUT.
 */

const ESCAPED_TAG_RE = /&amp;lt;|&lt;/i
const HTML_TAG_RE = /<\s*(pre|p|ul|ol|li|strong|em|h[1-6]|div|br|table)\b/i

export function decodeEscapedHtml(value: string): string {
  let next = String(value ?? '')
  for (let i = 0; i < 3; i += 1) {
    if (!ESCAPED_TAG_RE.test(next) && !/&gt;|&quot;|&#39;|&amp;/.test(next)) break
    next = next
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&')
  }
  return next
}

/** True when notes should render as HTML (raw or entity-escaped). */
export function looksLikeHtml(value: string): boolean {
  return HTML_TAG_RE.test(decodeEscapedHtml(value))
}

/** Decode escaped tags when the payload is HTML; leave plain text alone. */
export function normalizeBasecampHtml(value: string): string {
  const text = String(value ?? '')
  return looksLikeHtml(text) ? decodeEscapedHtml(text) : text
}
